import React from "react"
import {Helmet} from "react-helmet-async"

const AppMeta = ({title = process.env.REACT_APP_META_TITLE, description = ``, htmlAttributes = {lang: process.env.REACT_APP_META_LANG, itemscope: undefined, itemtype: `https://schema.org/`}, meta = []}) => {
    const metaData = {
        title: title,
        htmlAttributes: htmlAttributes,
        meta: meta.length ? meta : [
            {name: `description`, content: description},
            {name: `author`, content: process.env.REACT_APP_META_AUTHOR},
            {name: `viewport`, content: process.env.REACT_APP_META_VIEWPORT},

            {property: `og:type`, content: `website`},
            {property: `og:url`, content: ``},
            {property: `og:title`, content: title},
            {property: `og:description`, content: description},
            {property: `og:image`, content: process.env.REACT_APP_META_IMAGE},
            {property: `og:locale`, content: process.env.REACT_APP_META_LOCALE},

            {name: `twitter:title`, content: title},
        ]
    }

    return (
        <Helmet htmlAttributes={metaData.htmlAttributes} title={metaData.title} meta={metaData.meta}/>
    )
}

export default AppMeta
